export const isNullOrEmpty = (s) =>
  s === null || s === undefined || s.length === 0
